import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Subscription} from '../models/Subscription';
import {environment} from '../../environments/environment';
import {UpdateSubscriptionStatusRequestDto} from "../models/updateSubscriptionStatusRequestDto";

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {

  private readonly ENDPOINT_URL = `${environment.apiUrl}/subscriptions`;

  constructor(
    private http: HttpClient
  ) {
  }

  getSubscriptions(): Observable<Array<Subscription>> {
    return this.http.get<Array<Subscription>>(this.ENDPOINT_URL);
  }

  getSubscriptionById(id: string): Observable<Subscription> {
    const url = `${this.ENDPOINT_URL}/${id}`;
    return this.http.get<Subscription>(url);
  }

  createSubscription(subscription: Subscription): Observable<void> {
    return this.http.post<void>(this.ENDPOINT_URL, subscription);
  }

  updateSubscription(subscription: Subscription): Observable<void> {
    return this.http.put<void>(this.ENDPOINT_URL, subscription);
  }

  updateSubscriptionStatus(request: UpdateSubscriptionStatusRequestDto): Observable<void> {
    const url = `${this.ENDPOINT_URL}/status`;
    return this.http.patch<void>(url, request);
  }
}
